import api from '../../plugins/api';

//Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÑÐ°ÑÑÑ Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐµ (Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾, Ð² Ð±ÑÐ´ÑÑÐµÐ¼ Ð´Ð¾Ð»Ð¶Ð½Ñ Ð²ÑÐ·ÑÐ²Ð°ÑÑ Ð½Ð°Ñ ÑÑÐº Ð¸ Ð¿ÐµÑÐµÐ´Ð°Ð²Ð°ÑÑ ÑÑÐ°ÑÑÑ ÑÐ°Ð¼Ð¸)
const checkBankStatus = ({ chunkId, bankId }) => {
  return api.get('/api/bank/checkStatusAppeal', { chunkId, bankId });
};

export default checkBankStatus;
